/**
 * 充值档列表行为模块, 拉取获取、处理用户操作等
 */
import React, {Component} from 'react';
import PbAjax from '../../../lib/pbajax';
import publicpb from '../../../base/public.pb';
import optionlistpb from '../pb/optionlistpb';
import lang from '../../../lang';
import Loading from '../../../component/loading';

const pbajax = new PbAjax();

export default (ComposedComponent) => {
    return class OptionListAct extends Component {

        static defaultProps = {
            onSelectPay() {},
            uid: '',
            channel: ''
        };

        constructor(props) {
            super(props);

            this.state = {
                channel: props.channel,
                list: [],
                loading: true
            };
        }

        componentWillMount() {
            this.getOptionList();
        }

        componentWillReceiveProps(nextProps) {
            if (this.state.channel == nextProps.channel) {
                return;
            }
            this.setState({
                channel: nextProps.channel,
                loading: true
            }, ()=>{
                this.getOptionList();
            });
        }

        getOptionList() {
            let self = this;
            let uid = this.props.uid;
            let channel = this.state.channel;
            
            pbajax.do(
                {
                    service: 'mall',
                    api: channel == 'bk_atm' ? '/mall/recharge/config/bkatm': '/mall/recharge/config/h5',      
                    header: {
                        'Accept-Language': UP.Global.siteLanguage
                    },
                    inchina: 1
                }, 

                new optionlistpb.Mall.RechargeConfig.Request({
                    uid,
                    channel,
                }),

                (res) => {

                    let dataWrap = publicpb.Result.decode(res);
                    
                    if (dataWrap.code == 1) {                        

                        if (dataWrap.data.value === null) {
                            // console.log('option == null');
                        } else {

                            let data = optionlistpb.Mall.RechargeConfig.Response.decode(dataWrap.data.value);                         
                            
                            self.setState({
                                list: data.rechargeConfigs,
                                loading: false
                            });
                        } 
                    } else if (dataWrap.code == 16777215 ) {
                        // 系统错误
                        $.channel.emit('getOptionListError');
                    }
                }
            );
        }

        render() {
            if(this.state.loading) {
                return <Loading/>
            } else {
                return (
                    <ComposedComponent
                        {...this.state}
                        {...this.props}
                    />
                );
            }
            
        }
    }
}



// WEBPACK FOOTER //
// ./js/component/recharge/orderview/option-list-generator.js